import { createAsyncThunk } from "@reduxjs/toolkit";

import * as addressAPI from "../../../api/address";
import { IAddressCountry } from "../../../models/address";

/**
 * Loads the list of available countries for address forms.
 *
 * This data is used to populate country dropdown selects in customer address
 * creation and editing forms within the CSR app.
 *
 * @returns Promise resolving to an array of country objects
 */
export const loadCountries = createAsyncThunk(
    "csr/loadCountries",
    async (): Promise<IAddressCountry[]> => {
        return addressAPI.loadCountries();
    },
);
